/**
 * Configuração de Exportação de Layout (PNG) - Lite Version
 * 
 * ⚠️ SEM CACHE - Mudanças aqui refletem imediatamente após reload
 * 
 * 🚀 Usa `exportar-objetos-png-lite` (otimizado, 2-3x mais rápido)
 * 
 * ESCALA DINÂMICA:
 * A escala é calculada automaticamente em layoutPayloadBuilder.ts
 * baseada na altura_maxima_cm do material (das regras):
 * 
 * | Altura do material | Escala | Exemplo                    |
 * |--------------------|--------|----------------------------|
 * | > 200cm            | 0.05   | Sublimação (450cm)         |
 * | 151-200cm          | 0.12   | DTF Têxtil (200cm)         |
 * | 51-150cm           | 0.22   | DTF UV (100cm), Adesivo    |
 * | ≤ 50cm             | 0.50   | DTF UV A3 (28cm)           |
 * 
 * Objetivo: PNG final com altura ≤ 24cm
 */

export const LAYOUT_EXPORT_CONFIG = {
  /**
   * Resolução em DPI
   * Range: 72-1200
   * @default 300
   */
  resolucaoDpi: 300,

  /**
   * Habilitar transparência no PNG
   * @default true
   */
  transparencia: true,
} as const;

/**
 * Type helper para usar em outros arquivos
 */
export type LayoutExportConfig = typeof LAYOUT_EXPORT_CONFIG;


